<template lang="pug">
.container.mt-4.mt-sm-5.mb-6: .row
    .col-md-6(v-show="accountActive")
        .card.shadow-sm.mb-4: .card-body
            h4.card-title Neues Protokoll erstellen
            p.card-text Starten Sie eine neue Berechnung mit dem Berechnungsassistenten.
            router-link.btn.btn-primary(to="/protokolle/erstellen") Assistent starten

        .card.shadow-sm.mb-4: .card-body
            small.text-muted 20. Juni 2022
            h4.card-title Neue Funktion: Taschenrechner
            p Für das Raumvolumen oder die (fiktive) Nennleistung sind oft kleinere Berechnungen nötig, wie bspw. "Fläche mal Raumhöhe".
            p
                span.calculator-icon: font-awesome-icon(icon="square-root-alt", size="2x")
                | Um Ihnen in diesen Fällen die Eingabe zu erleichtern, können Sie nun bei allen Feldern mit diesem Zeichen simple, mathematische Formeln verwenden (mit #[code +], #[code -], #[code *], #[code /]).
            p Aus mathematischen Ausrücken (bspw. #[code 12*2,4] oder #[code 10 + (8 + 3) * 2]) wird bei Verlassen des Feldes automatisch das errechnete Ergebnis.
            p Hier können Sie die Funktion direkt testen:
            numeric-input(v-model="mathExample", allowMath=true)

    .col-md-6
        .card.shadow-sm.mb-4
            .card-header.font-weight-bold Neueste Protokolle

            .card-body.text-center(v-if="!latestProtocols")
                i Noch keine Protokolle angelegt

            .list-group.list-group-flush(v-else)
                .list-group-item(v-for="protocol in latestProtocols")
                    .d-flex.justify-content-between
                        router-link(v-if="accountActive", :to="`/protokolle/erstellen?id=` + protocol.id") {{ protocol.title }}
                        span(v-else) {{ protocol.title }}

                        span {{ formatDate(protocol.createdAt) }}

        .card.shadow-sm.mb-4(v-if="showRatingForm"): .card-body
            h4.card-title Bewerten Sie Luftverbundrechner.de
            p Bitte nehmen Sie sich einen Augenblick Zeit und bewerten Sie Ihre Erfahrung mit unserer Software.
            rating-form
</template>

<script>
import axios from 'axios'
import { formatDate } from '@/utils/format'
import NumericInput from '@/components/NumericInput'
import RatingForm from '@/components/RatingForm'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSquareRootAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faSquareRootAlt)

export default {
    components: {
        NumericInput,
        RatingForm
    },
    data () {
        return {
            latestProtocols: [],
            showRatingForm: false,
            mathExample: null
        }
    },
    computed: {
        accountActive () {
            return this.$store.getters.accountActive
        }
    },
    async created () {
        this.latestProtocols = await axios.get(`${process.env.VUE_APP_API_URL}/protocols?limit=5`).then(res => res.data.protocols)
        // check onload, if rating form should be hidden
        if (!this.$store.getters.userRated) {
            this.showRatingForm = true
        }
    },
    methods: {
        formatDate
    }
}
</script>

<style scoped>
.calculator-icon {
    color: #ccc;
    line-height: 2;
    float: left;
    margin-right: 1rem;
    margin-top: 1rem;
}
</style>
